import React from 'react';
import {
  FormControl,
  Grid, InputLabel, TextField,
  Button,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';
import { PopoverComponentRef } from '../Popover';

const validationSchema = yup.object().shape({
  notes: yup.string().required('Reason of reject is required.'),
});

export type RejectFormValues = {
  notes: string;
};

interface RejectFormProps extends PopoverComponentRef {
  onReject: (data: RejectFormValues) => void;
}

const RejectForm = function RejectForm(props: RejectFormProps) {
  const { onReject, close } = props;
  const resolver = useYupValidationResolver(validationSchema);
  const methods = useForm<RejectFormValues>({
    resolver,
  });
  const {
    handleSubmit, control,
  } = methods;

  const submitHandler = (data: RejectFormValues) => {
    onReject(data);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <div className="p-4 pt-6">
        <Grid container direction="column" minWidth={400} spacing={2} p={2}>
          <Grid item md={12}>
            <Controller
              name="notes"
              control={control}
              render={({ field, fieldState }) => (
                <FormControl variant="standard" className="relative flex-1 w-full">
                  <InputLabel shrink className="text-[1.2rem] font-semibold -mt-[20px]" error={fieldState.error && true}>
                    Reason to Reject
                  </InputLabel>
                  <TextField autoFocus error={!!fieldState.error} rows={5} {...field} multiline placeholder="Type the reason to reject..." />
                  {fieldState.error?.message && (
                    <span className="absolute -bottom-5 text-xs text-primary">
                      {fieldState.error?.message}
                    </span>
                  )}
                </FormControl>
              )}
            />
          </Grid>
          <Grid item md={12} gap={2} className="mt-2 flex justify-center">
            <Button
              variant="outlined"
              size="small"
              onClick={close}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              size="small"
            >
              Reject
            </Button>
          </Grid>
        </Grid>
      </div>
    </form>
  );
};

RejectForm.defaultProps = {

};

RejectForm.propTypes = {

};

export default RejectForm;
